import React from "react";
import { useIdleTimer } from "react-idle-timer";
import { Grid, PlatformBase, PlatformDialog, pxToRem, Typography } from "@platform/style";
import { isUserAuthenticated, redirectToLogin, redirectToLogout } from "../../../platform-core";

interface IdleWatchProps {
  timeout: number;
  promptBeforeIdle: number;
}

export const IdleWatch = ({ timeout, promptBeforeIdle }: IdleWatchProps) => {
  const [remaining, setRemaining] = React.useState<number>(timeout);
  const [open, setOpen] = React.useState<boolean>(false);

  React.useEffect(() => {
    isUserAuthenticated().then((isAuthenticated) => {
      if (!isAuthenticated) {
        redirectToLogin();
      }
    });
  });

  React.useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  });

  const onIdle = () => {
    redirectToLogout();
  };

  const onActive = () => {
    setOpen(false);
  };

  const onPrompt = () => {
    setOpen(true);
  };

  const handleStillHere = () => {
    activate();
  };

  const { getRemainingTime, activate } = useIdleTimer({
    onIdle,
    onActive,
    onPrompt,
    timeout,
    promptBeforeIdle,
    throttle: 500,
    crossTab: true,
    syncTimers: 500,
  });

  return (
    <PlatformBase>
      <PlatformDialog
        open={open}
        title={"Idle Timeout"}
        onClose={handleStillHere}
        closeLabel={"stay logged in"}
      >
        <Grid
          container
          spacing={2}
          direction="row"
          justifyContent="space-around"
          alignItems="center"
          sx={{ paddingTop: pxToRem(20), paddingBottom: pxToRem(20) }}
        >
          <Grid item>
            <Typography component={"span"} variant={"body1"}>
              You have been idle too long and will be automatically logged out in {remaining}{" "}
              seconds.
            </Typography>
          </Grid>
        </Grid>
      </PlatformDialog>
    </PlatformBase>
  );
};
